import PropTypes from 'prop-types';

const Radio = ({ label, value, id, dataTest, onChange, required, disabled, error, checked }) => {
  let className =
    'border-2 border-grey-200 bg-white shadow-sm hover:border-grey-300 focus:ring-0 focus:ring-transparent focus:border-purple-100 focus:checked:bg-purple-100 hover:checked:border-purple-100 hover:checked:bg-purple-100 checked:bg-purple-100 block w-6 h-6 p-2 rounded-sm font-sans text-base font-normal mt-1 disabled:bg-grey-100 disabled:checked:bg-[#f2f2f2] hover:disabled:checked:bg-[#f2f2f2] disabled:border-grey-200 disabled:checked:border-grey-200 disabled:text-grey-400';

  return (
    <label className="inline-flex justify-start items-center -mt-3 mr-8">
      <div className="pr-2">
        <input
          type="radio"
          name={id}
          id={id}
          value={value}
          checked={checked}
          data-testid={dataTest}
          onChange={onChange}
          disabled={disabled}
          className={className}
        />
      </div>
      {label ? (
        <span
          className={`block font-sans text-sm font-bold text-grey-400 pt-1 ${
            error ? 'text-red-100' : ''
          }`}
          data-testid={`${dataTest}-label`}
        >
          {label}
          {required ? <span className={error ? 'text-red-100' : 'text-blue-100'}>*</span> : null}
        </span>
      ) : null}
    </label>
  );
};
Radio.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  dataTest: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  checked: PropTypes.bool
};

export default Radio;
